import { StyleSheet } from 'lib/paypalphrodite'
import * as media from '../../lib/styles/media-queries'
import { v2illustrationblack, v2green400 } from '@paypalcorp/pp-react'
import _ from 'lodash'
import serverProps from '../utils/serverProps'
import { isDw2Repaint } from 'experiments/dw2Repaint'

const CDN_HOST_NAME = _.get(serverProps, 'cdnHostName')

const primaryText = {
  fontSize: '16px',
  color: '#2C2E2F',
  lineHeight: '24px',
}

const subText = {
  fontSize: '14px',
  color: '#687173',
  lineHeight: '20px',
}

const thirdPartyText = {
  fontSize: '12px',
  padding: '0 7px',
  lineHeight: '20px',
}

export default StyleSheet.create({
  wrapper: {
    padding: isDw2Repaint() ? '1rem 2.75rem 0 2.75rem' : '0 44px',
    [media.smallAndSmaller]: {
      padding: '0 20px',
    },
  },
  currencyConversionLinkContainer: {
    borderTop: 'solid 1px #eeeeee',
    borderBottom: 'solid 1px #eeeeee',
    height: '56px',
    lineHeight: '56px',
  },
  currencyConversionDescription: {
    paddingLeft: '0.5em',
  },
  currencyConversionLink: {
    fontSize: '13px',
    paddingRight: '1em',
  },
  installmentPlanDropdown: {
    margin: '1em 0 0.5em',
  },
  clearfix: {
    ':after': {
      content: '""',
      display: 'table',
      clear: 'both',
    },
  },
  firstTimeUserHelpInfo: {
    textAlign: 'left',
    transition: 'all 0.5s ease',
    maxHeight: '0px',
    opacity: '0',
    overflow: 'hidden',
  },
  firstTimeUserHelpInfoEnter: {
    marginTop: '1em',
    maxHeight: '300px',
    opacity: '1',
  },
  cardPreview: {
    content: '',
    width: '50px',
    height: '25px',
    position: 'absolute',
  },
  visa: {
    background: `url(${CDN_HOST_NAME}/webstatic/sprite/sprite_logos_wallet_2x.png) no-repeat 0px -98px`,
  },
  mcard: {
    background: `url(${CDN_HOST_NAME}/webstatic/sprite/sprite_logos_wallet_2x.png) no-repeat 0px -200px`,
  },
  amex: {
    background: `url(${CDN_HOST_NAME}/webstatic/sprite/sprite_logos_wallet_2x.png) no-repeat 0px -300px`,
  },
  disc: {
    background: `url(${CDN_HOST_NAME}/webstatic/sprite/sprite_logos_wallet_2x.png) no-repeat 0px -400px`,
  },
  cvvComponent: {
    marginTop: '1.5em',
  },
  cvvInfo: {
    fontSize: '13px',
    color: '#6c7378',
  },
  rtrcvvInfo: {
    marginBottom: '8px',
  },
  cvvInputLogo: {
    content: '',
    width: '70px',
    height: '90px',
    position: 'absolute',
    right: '10px',
    top: '-42px',
  },
  cvvInputLogoBack: {
    background: `url(${CDN_HOST_NAME}/webstatic/sprite/sprite_logos_wallet_2x.png) no-repeat 23px -646px`,
  },
  cvvInputLogoFront: {
    background: `url(${CDN_HOST_NAME}/webstatic/sprite/sprite_logos_wallet_2x.png) no-repeat 23px -746px`,
  },
  fundingSourceWrapper: {
    margin: '15px 0 0 0',
  },
  fundingSourceTitleLogoWrapper: {
    width: '52%',
    padding: '0 10px 0 0',
  },
  fundingSourceAmount: {
    width: '48%',
    paddingTop: 3,
    paddingRight: 0,
  },
  feeWaived: {
    color: v2green400,
  },
  preferredBadge: {
    marginLeft: 60,
    padding: '1px 8px',
    background: '#eaf7e9',
    display: 'inline-block',
  },
  preferredBadgeText: {
    fontSize: 11,
    margin: 0,
  },
  fundingSourceLogo: {
    margin: isDw2Repaint() ? '0 1rem' : '1px 10px 0 -4px',
  },
  fundingSourceTitle: {
    display: 'inline-block',
    width: 290,
    margin: '3px 0 10px 0',
    float: 'right',
  },
  preventIncorrectTitleWrap: {
    // because the design is specific that the text of the label not wrap beneath checkbox
    display: 'inline-block',
    width: 'calc(100% - 57px)', // the full width, minus the size logo
  },
  choiceCardArt: {
    borderRadius: 3,
    marginLeft: 5,
    maxWidth: 40,
    boxShadow: '0px 1px 5px rgba(78, 70, 70, 0.47)',
  },
  fundingSecondaryText: {
    margin: '0 0 10px 0',
    float: 'right',
    lineHeight: '1.23rem',
  },
  ppcreditSpecialOfferText: {
    color: '#6c7378',
    [media.smallAndSmaller]: {
      margin: '-5px 0 0',
      lineHeight: 1.6,
    },
  },
  offerEligibilityText: {
    color: v2illustrationblack,
    fontSize: 14,
  },
  feeInfoTooltip: {
    top: '5px',
    color: '#2c2e2f',
  },
  selectedFundingOption: {
    borderRadius: 0,
  },
  rtrFundingSourceTitle: {
    ...primaryText,
    marginBottom: 0,
  },
  rtrAccountType: {
    ...primaryText,
    fontSize: '13px',
    marginBottom: 0,
  },
  rtrFundingSourceTitleENSubText: {
    ...subText,
    marginTop: '-6px',
  },
  rtrAccountTypeENSubText: {
    ...subText,
    fontSize: '13px',
  },
  rtrFundingFeeContent: {
    ...primaryText,
    fontSize: '13px',
  },
  rtrFundingFeeENSubContent: {
    ...subText,
    fontSize: '13px',
  },
  rtrConversionText: {
    ...primaryText,
    lineHeight: '30px',
  },
  rtrConversionENSubText: {
    ...subText,
    paddingBottom: '6px',
  },
  rtrPrimaryText: {
    ...primaryText,
  },
  rtrENSubText: {
    ...subText,
  },
  rtrPrimaryTextSmall: {
    fontSize: '0.9375rem',
  },
  thirdParty: {
    marginTop: '12px',
    ...thirdPartyText,
  },
  rtrThirParty: {
    marginBottom: '0px',
  },
  rtrThirPartyInfoENSubText: {
    color: '#687173',
    marginTop: '0px',
    ...thirdPartyText,
  },
})
